import { useAccess } from "@templates/course/hooks/useAccess";
import { COURSE_TYPE } from "@types";
import { FC, useState } from "react";
import ProductSidebarPriceWithDiscount from "./PriceWithDiscount";
import PublishedProductPageActions from "./actions/Published";
import NotPublishedSidebarAction from "./actions/NotPublished";
import { useNonAccess } from "@templates/course/hooks/useNonAccess";
import ProductPageSidebarPublishedFooter from "./footer/Published";
import RecordignProductSidebarFooter from "./footer/Recording";
import ProductCoverImage from "./CoverImage";
import { useAppContext } from "@context/app";
import { useRouter } from "next/router";
import { useCartContext } from "@context/cart";
import dynamic from "next/dynamic";
const DiscountCountDown = dynamic(() => import("./Countdown"), { ssr: false });

export const CourseTypeTranslates = {
  [COURSE_TYPE.COURSE]: "آموزش",
  [COURSE_TYPE.WEBINAR]: "وبینار",
  [COURSE_TYPE.BLIND]: "آموزش",
  [COURSE_TYPE.PODCAST]: "پادکست",
  [COURSE_TYPE.AUDIOBOOK]: "کتاب صوتی",
  [COURSE_TYPE.PACK]: "بسته آموزشی",
  [COURSE_TYPE.EXAM]: "آزمون",
  [COURSE_TYPE.SERVICES]: "خدمات",
  [COURSE_TYPE.PACKAGE]: "بسته آموزشی",
  [COURSE_TYPE.NOTE]: "یادداشت",
  [COURSE_TYPE.PRACTICE]: "تمرین",
  [COURSE_TYPE.PHYSICAL]: "آموزش",
  [COURSE_TYPE.TEXT]: "آموزش متنی",
  [COURSE_TYPE.BOOK]: "کتاب",
  [COURSE_TYPE.VIDEO]: "آموزش ویدیویی",
};

const DefaultProductPageSidebarContent: FC = () => {
  const { courseData } = useAccess();
  const { isPublished } = useNonAccess();
  const { push, asPath } = useRouter();
  const {
    product: {
      is_free,
      fara_festival: { discount, price_after_discount } = {},
      id,
    },
    user: { is_notify_on_publish },
  } = courseData;

  const showDiscount = (price_after_discount || discount) && !is_free;

  const [notified, setNotified] = useState(Boolean(is_notify_on_publish));
  const [loading, setLoading] = useState(false);
  const { preRegister } = useCartContext();
  const {
    user: { isLoggedIn },
  } = useAppContext();

  const onPreRegister = async () => {
    if (!isLoggedIn) {
      push("/register?next=" + encodeURIComponent(asPath));
      return false;
    } else {
      setLoading(true);
      const res = await preRegister(id);
      setLoading(false);
      setNotified(res);
    }
  };

  return (
    <div className="w-full px-5 py-5 lg:px-6 lg:py-5 flex flex-col shadow-primary-md  rounded-12 bg-fds-primary  h-fit gap-3">
      <>
        <ProductCoverImage />
        <div className="w-full">
          {isPublished && (
            <div className="flex w-full justify-between items-start">
              <p className="headline-xxsm text-fds-secondary text-right truncate">
                هزینه{" "}
                {courseData.product.attribute_type === COURSE_TYPE.COURSE
                  ? "آموزش"
                  : courseData.product.attribute_type === COURSE_TYPE.WEBINAR
                    ? "وبینار"
                    : ""}
              </p>
              {is_free ? (
                <h6 className="headline-md text-fds-primary">رایگان</h6>
              ) : (
                <ProductSidebarPriceWithDiscount />
              )}
            </div>
          )}
          {showDiscount && <DiscountCountDown />}
        </div>
        <div className="w-full flex gap-2">
          {isPublished ? (
            <PublishedProductPageActions />
          ) : (
            <NotPublishedSidebarAction
              {...{ loading, notified, onPreRegister }}
            />
          )}
        </div>
      </>
      {isPublished ? (
        <ProductPageSidebarPublishedFooter />
      ) : (
        <RecordignProductSidebarFooter />
      )}
    </div>
  );
};

export default DefaultProductPageSidebarContent;
